module.exports = __webpack_public_path__ + "static/media/keyLeft.14ac166b.png";